import { render, staticRenderFns } from "./ListCandidate.vue?vue&type=template&id=889d6d34"
import script from "./ListCandidate.vue?vue&type=script&lang=js"
export * from "./ListCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListCandidate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889d6d34')) {
      api.createRecord('889d6d34', component.options)
    } else {
      api.reload('889d6d34', component.options)
    }
    module.hot.accept("./ListCandidate.vue?vue&type=template&id=889d6d34", function () {
      api.rerender('889d6d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/views/ListCandidate.vue"
export default component.exports